var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex items-center pt-10 pl-3 pr-3"},[(_vm.loadPath)?_c('AccountResumeCardPage',{attrs:{"shared-resume":"","load-path":_vm.loadPath}}):_c('ErrorView',{attrs:{"code":400,"title":"Failed to load resume"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }